import { useState } from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleNewsletter = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    try {
      const body = new URLSearchParams({ email });
      await fetch("https://readdy.ai/api/form/d7ckf2k5q56ra7tuf91g", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    }
  };

  return (
    <footer className="bg-stone-900 text-white">
      {/* Newsletter */}
      <div className="bg-amber-500">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8 py-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="text-white text-xl font-bold">Stay Ahead of Global Trade</h3>
            <p className="text-amber-100 text-sm mt-1">Get the latest product trends, supplier updates, and trade insights.</p>
          </div>
          {submitted ? (
            <div className="flex items-center gap-2 text-white font-semibold">
              <i className="ri-checkbox-circle-line text-xl"></i>
              <span>Subscribed! Thank you.</span>
            </div>
          ) : (
            <form
              data-readdy-form
              onSubmit={handleNewsletter}
              className="flex w-full md:w-auto gap-2"
            >
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email address"
                required
                className="flex-1 md:w-72 px-4 py-2.5 rounded-full text-sm text-gray-800 outline-none"
              />
              <button
                type="submit"
                className="bg-stone-900 hover:bg-stone-800 text-white text-sm font-semibold px-6 py-2.5 rounded-full transition-colors whitespace-nowrap cursor-pointer"
              >
                Subscribe
              </button>
            </form>
          )}
        </div>
      </div>

      {/* Main footer */}
      <div className="max-w-screen-2xl mx-auto px-4 md:px-8 py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10">
        {/* Brand */}
        <div className="lg:col-span-2">
          <Link to="/" className="flex items-center gap-2 mb-4">
            <img
              src="https://static.readdy.ai/image/3fc89005e5f8f541d0781d07714068dd/b31ed3570265bb91107b593ba40da4ad.jpeg"
              alt="CrownGlobal Logo"
              className="h-12 w-auto object-contain rounded"
            />
          </Link>
          <p className="text-stone-400 text-sm leading-relaxed max-w-xs">
            Crown Global Factory &amp; Buyer — the best platform where tens of millions of buyers purchase containers directly from factories worldwide. Your trusted B2B marketplace for global trade.
          </p>
          <a
            href="https://www.crownglobalfactoryandbuyer.com"
            rel="nofollow"
            className="text-amber-400 text-xs mt-2 inline-block hover:underline cursor-pointer"
          >
            www.crownglobalfactoryandbuyer.com
          </a>
          <div className="flex items-center gap-3 mt-5">
            {[
              { icon: "ri-facebook-circle-fill", label: "Facebook" },
              { icon: "ri-tiktok-fill", label: "TikTok" },
              { icon: "ri-twitter-x-fill", label: "Twitter" },
              { icon: "ri-youtube-fill", label: "YouTube" },
            ].map((s) => (
              <a
                key={s.label}
                href="#"
                aria-label={s.label}
                className="w-9 h-9 flex items-center justify-center rounded-full border border-stone-600 text-stone-400 hover:border-amber-400 hover:text-amber-400 transition-colors cursor-pointer"
              >
                <i className={`${s.icon} text-base`}></i>
              </a>
            ))}
          </div>
        </div>

        {/* Trade */}
        <div>
          <h4 className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">Trade</h4>
          <ul className="space-y-2.5">
            {[
              { label: "Marketplace", path: "/marketplace" },
              { label: "Product Listings", path: "/product-listings" },
              { label: "Buyer Post", path: "/buyer-post" },
              { label: "Vendor Dashboard", path: "/vendor-dashboard" },
              { label: "Premium Ads", path: "/premium-ads" },
            ].map((l) => (
              <li key={l.path}>
                <Link to={l.path} className="text-stone-400 hover:text-amber-400 text-sm transition-colors cursor-pointer">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Services */}
        <div>
          <h4 className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">Services</h4>
          <ul className="space-y-2.5">
            {[
              { label: "Secure Payment", path: "/secure-payment" },
              { label: "Overseas Warehouse", path: "/overseas-warehouse" },
              { label: "Freight Services", path: "/freight-services" },
              { label: "Social Stars", path: "/social-stars" },
              { label: "Trade Assurance", path: "/" },
            ].map((l) => (
              <li key={l.label}>
                <Link to={l.path} className="text-stone-400 hover:text-amber-400 text-sm transition-colors cursor-pointer">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">Contact</h4>
          <ul className="space-y-3">
            <li className="flex items-start gap-2 text-stone-400 text-sm">
              <i className="ri-map-pin-line mt-0.5 text-amber-400 shrink-0"></i>
              <span>888 Crown Tower, Global Trade Center, New York, NY 10001, USA</span>
            </li>
            <li className="flex items-center gap-2 text-stone-400 text-sm">
              <i className="ri-phone-line text-amber-400 shrink-0"></i>
              <span>+1 (800) 555-CROWN</span>
            </li>
            <li className="flex items-center gap-2 text-stone-400 text-sm">
              <i className="ri-mail-line text-amber-400 shrink-0"></i>
              <span>trade@crownglobal.com</span>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-stone-800">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-stone-500 text-xs">© 2026 Crown Global Factory &amp; Buyer — <a href="https://www.crownglobalfactoryandbuyer.com" rel="nofollow" className="hover:text-amber-400 transition-colors cursor-pointer">www.crownglobalfactoryandbuyer.com</a>. All rights reserved.</p>
          <div className="flex items-center gap-4">
            {["Privacy Policy", "Terms of Service", "Cookie Policy"].map((t) => (
              <a key={t} href="#" className="text-stone-500 hover:text-amber-400 text-xs transition-colors cursor-pointer whitespace-nowrap">
                {t}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
